module.exports = __webpack_public_path__ + "static/flags/GV-d57402625f60e19fd2234b6b66b58329.gif";